<template>
  <article class="vch-card">
    <a class="vch-card__link" :href="link" v-vch-tagging:productclick="{ data: taggingData.click }">
      <div class="vch-card__thumbnail vch-card__large article">
        <img
          class="lazyload"
          :alt="imageAlt"
          :src="image.src"
          :data-srcset="image.srcset"
          :data-sizes="imageSizes"
        />
      </div>
      <div class="vch-card__heading">
        <h3 class="heading-md-em mb-xxs">
          {{ title }}
        </h3>
        <p class="vch-card__text text-body">
          {{ description }}
        </p>
      </div>
    </a>
  </article>
</template>
<script>
export default {
  name: 'vch-card-article',
  props: {
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    link: {
      type: String,
      required: false,
    },
    image: {
      type: Object,
      required: false,
    },
    taggingData: {
      type: Object,
      required: false,
    },
    imageSizes: {
      type: String,
      default:
        '(min-width: 1600px) 368px, (min-width: 1280px) 288px, (min-width: 1024px) 234px, 50vw',
    },
  },
  computed: {
    imageAlt() {
      return this.image?.altText || 'Article Image';
    },
  },
};
</script>
